import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../api/baseUrl";
import PastTreatmentTr from "./PastTreatmentTr";
import HistoryIcon from "@mui/icons-material/History";

function PastTreatment() {
  const { ID } = useParams();
  const [data, setdata] = useState([]);
  const [count, setcount] = useState(0);

  useEffect(() => {
    baseUrl
      .get("treatment/findAllTreatmentByTreatmentId", {
        headers: { treatmentid: ID },
      })
      .then((response) => { console.log(response.data.data); setdata(response.data.data); setcount(response.data.count) })
      .catch((error) => console.log(error));
  }, [ID]);

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="flex items-center gap-2.5 bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden p-2">
        <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
          <HistoryIcon className="text-amber-600" sx={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="text-sm font-bold text-slate-800">Past Treatments</h3>
          <p className="text-xs text-slate-500">{count} records</p>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-slate-100">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Date</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Treatment</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Note</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Dentist</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Price</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data?.map((item: any, i: number) => (
              <PastTreatmentTr key={i} item={item} />
            ))}
          </tbody>
        </table>
        {count === 0 && (
          <div className="py-8 text-center text-slate-400">
            <HistoryIcon sx={{ fontSize: 36 }} className="mb-2" />
            <p className="text-xs">No past treatments found</p>
          </div>
        )}
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {count === 0 ? (
          <div className="bg-white rounded-lg p-6 text-center text-slate-400">
            <HistoryIcon sx={{ fontSize: 36 }} className="mb-2" />
            <p className="text-xs">No past treatments found</p>
          </div>
        ) : (
          data?.map((item: any, i: number) => (
            <PastTreatmentTr key={i} item={item} isMobile />
          ))
        )}
      </div>
    </div>
  );
}

export default PastTreatment;
